import React from 'react';
import { Button } from '@/components/ui/button';

interface RejectedScreenProps {
  approvalNote?: string;
  onSignOut: () => void;
}

/**
 * Shown when an admin rejects the website submission. Extracted from the
 * inline JSX that lived in App.tsx so it shares the same Overlay chrome as
 * the other terminal screens.
 */
const RejectedScreen: React.FC<RejectedScreenProps> = ({ approvalNote, onSignOut }) => {
  return (
    <div className="h-full flex flex-col bg-white rounded-2xl overflow-hidden">
      <div className="flex flex-col lg:grid lg:grid-cols-3 flex-1 min-h-0 overflow-hidden">
        <div className="lg:col-span-3 flex flex-col flex-1 min-h-0 overflow-y-auto items-center justify-center px-6">
          <div className="max-w-md w-full text-center">
            <div className="mb-6 flex justify-center">
              <div className="w-16 h-16 rounded-full flex items-center justify-center bg-red-50">
                <svg className="w-10 h-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <circle cx="12" cy="12" r="10" />
                  <path strokeLinecap="round" d="M12 8v4m0 4h.01" />
                </svg>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Changes Needed</h1>
            <p className="text-gray-500 text-sm mb-2 leading-relaxed">
              Your website submission has been reviewed and requires some changes.
            </p>
            {approvalNote && (
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 text-left">
                <p className="text-sm font-medium text-amber-800 mb-1">Reviewer note:</p>
                <p className="text-sm text-amber-700">{approvalNote}</p>
              </div>
            )}
            <Button variant="outline" onClick={onSignOut}>
              Sign Out
            </Button>
          </div>
        </div>
        <div className="hidden lg:flex lg:col-span-2 bg-gray-100 border-l border-gray-100 rounded-tr-2xl rounded-br-2xl" />
      </div>
    </div>
  );
};

export default RejectedScreen;
